export const NATIONALITIES = [
  'American', 'Argentinian', 'Australian', 'Austrian', 'Belgian', 'Brazilian', 'British',
  'Bulgarian', 'Cambodian', 'Canadian', 'Chilean', 'Chinese', 'Colombian', 'Croatian',
  'Czech', 'Danish', 'Dutch', 'Egyptian', 'Estonian', 'Filipino', 'Finnish', 'French',
  'German', 'Greek', 'Hungarian', 'Icelandic', 'Indian', 'Indonesian', 'Iranian', 'Irish',
  'Israeli', 'Italian', 'Japanese', 'Kazakh', 'Korean', 'Laotian', 'Latvian', 'Lithuanian',
  'Malaysian', 'Maltese', 'Mexican', 'Moroccan', 'Myanmar', 'Nepalese', 'New Zealander',
  'Norwegian', 'Pakistani', 'Peruvian', 'Polish', 'Portuguese', 'Romanian', 'Russian',
  'Saudi', 'Serbian', 'Singaporean', 'Slovak', 'Slovenian', 'South African', 'Spanish',
  'Swedish', 'Swiss', 'Taiwanese', 'Thai', 'Turkish', 'Ukrainian', 'Vietnamese', 'Other',
]

export function useNationalities() {
  return { NATIONALITIES }
}
